<template>
  <div class="widget_input_wrapper">
    <h1>{{ title }}</h1>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "widget_input_wrapper",
  props: {
    title: {
      type: String,
      default: "Input name",
    },
  },
  data() {
    return {};
  },
  watch: {},
  mounted() {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.widget_input_wrapper {
  padding-top: 5px;
  padding-bottom: 10px;
  width: 100%;
  h1 {
    margin-bottom: 10px;
    color: #707070;
    font-weight: 500;
    font-size: 14px;
  }
}
</style>
